import type { Theme } from '../../types/theme';

export const vergeTheme: Theme = {
  id: 'verge',
  name: 'The Verge',
  description: 'Acid-mint and ultraviolet accents for tech editorial media',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/theverge/DESIGN.md',
  visualKeywords: ['mint accent', 'ultraviolet', 'editorial', 'broadsheet', 'tech media'],
  colors: {
    background: '#ffffff',
    surface: '#f7f7f7',
    surfaceElevated: '#f7f7f7',
    textPrimary: '#111111',
    textSecondary: '#666666',
    textMuted: '#666666',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#00c7b7',
    primaryHover: '#0fd6c6',
    primaryActive: '#00a999',
    accent: '#00c7b7',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'editorial',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
